export const showDeviceSelected = (device, { selectedFeature }): boolean => {
  if (!selectedFeature) return false
  return selectedFeature.feature.id === `device:${device.pid}`
}
